import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="forms--prepare-flow-configurations"
export default class extends Controller {
  static targets = ["type"];

  connect() {
    this.typeSelect = new TomSelect(this.typeTarget);
  }

  disconnect() {
    this.typeSelect.destroy();
  }
}
